<template>
  <div class="showcase">
    <div class="goods-list">
      <div class="goods-item del_tips--cont" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
        <div class="del_tips" @click.stop="cancelCollect(item)">
          <i class="el-icon-delete"></i>
        </div>
        <div class="goods-item-img">
          <div class="goods-img">
            <el-image class="image" :src="item.cover" @error="handleError" />
          </div>
        </div>
        <div class="goods-item-info">
          <div class="title">
            <span class="txt ellipsis">{{ item.title }}</span>
            <span class="category_name ellipsis">{{ item.category_name }}</span>
          </div>
          <div class="time ellipsis">
            <span class="tit">活动时间：</span>
            <span class="txt">{{ item.start_time | dateFormat }} / {{ item.end_time | dateFormat }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCollect } from "@/api/common"
import dayjs from "dayjs"
export default {
  name: "MyActivityList",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => new Array(),
    },
  },
  filters: {
    dateFormat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY.MM.DD HH:mm:ss")
    },
  },
  data() {
    return {
      moreicon: require("@/assets/home/open.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted() { },
  methods: {
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    toDetail(item) {
      window.localStorage.setItem("menuId", 1)
      this.$store.dispatch("setmenuid", 1)
      this.$router.push({
        path: "/home/activity/detail",
        query: {
          id: item.id || "",
        },
      })
    },
    // 取消收藏
    cancelCollect(data) {
      let params = {
        id: data.id,
        type: 3
      }
      setCollect(params).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '取消采集成功!'
          })
          this.$emit('updateComponent')
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
.showcase {
  .goods-list {
    display: flex;
    justify-content: flex-start;
    // align-items: center;
    flex-wrap: wrap;

    .goods-item {
      width: calc((100% - 60px) / 3);
      height: 390px;
      background-color: #fff;
      border-radius: 5px;
      overflow: hidden;
      margin: 30px 0px 0px 30px;
      flex-shrink: 1;
      box-sizing: border-box;
      // cursor: pointer;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);

      // &:hover {
      //   border: 1px solid rgb(9, 235, 178);
      // }
      .goods-item-img {
        position: relative;
        height: calc(100% - 120px);
        overflow: hidden;
        cursor: pointer;

        .goods-img {
          width: 100%;
          height: 100%;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }

        .default-img {
          width: 100%;
          height: 235px;
          // background: #daebfc;
          text-align: center;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }
      }

      .goods-item-info {
        padding: 0px 15px;
        background: #ffffff;
        // border: 1px solid red;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .txt {
            display: inline-block;
            flex: 1;
            color: #000;
            font-size: 16px;
            font-weight: 500;
            padding-right: 8px;
          }

          .category_name {
            display: inline-block;
            width: 80px;
            padding: 6px 10px;
            border-radius: 5px;
            background-color: #005cbb;
            color: #fff;
            font-size: 12px;
            box-sizing: border-box;
            text-align: center;
          }
        }

        .tit,
        .txt {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          border-radius: 12px;
        }
      }
    }

    .goods-item:nth-child(3n + 1) {
      margin-left: 0px;
    }
  }
}

@media screen and (max-width: 640px) {
  .showcase {
    .goods-list {
      .goods-item {
        width: calc((100% - 10px) / 2);
        height: auto;
        margin: 10px 0 0 10px;

        .goods-item-img {
          height: 120px;
        }

        .goods-item-info {
          height: auto;
          padding: 8px;

          .title {
            .txt {
              font-size: 13px;
            }
          }
        }
      }

      .goods-item:nth-child(2n + 1) {
        margin-left: 0;
      }

      .goods-item:nth-child(3n + 1) {
        margin-left: 10px;
      }

      .goods-item:nth-child(2n + 1) {
        margin-left: 0 !important;
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .showcase {
    .goods-list {
      .goods-item {
        width: calc((100% - 40px) / 3);
        margin: 20px 0 0 20px;
      }
    }
  }
}
</style>